import React from 'react';
import PrimaryStage from 'commonComponents/Stages/PrimaryStage/PrimaryStage';
import FromInvestors from './FromInvestors/FromInvestors';
import OurValues from './OurValues/OurValues';
import TextWithImages from 'commonComponents/sections/TextWithImages/TextWithImages';
import EmployeePhoto from 'oldAssets/images/static_pages/our_mission/Robin.webp';
import OurEmployees from 'commonComponents/OurEmployees/OurEmployees';
import styles from '../pages.module.scss';

const OurMissionPage = ({
  locale, banner, fromInvestors, ourValues, corporateCulture, ourEmployees,
  investmentFunnelLink
}) => {
  const context = require.context('oldAssets/images/static_pages/our_mission', false, /photo_\d\.webp$/);

  return (
    <div className={ styles.Page }>
      <PrimaryStage { ...banner } pageName="ourMission" />
      <FromInvestors { ...fromInvestors } link={ investmentFunnelLink } />
      <OurValues { ...ourValues } locale={ locale } />
      <TextWithImages
        { ...corporateCulture }
        context={ context }
        anchor='corporate-culture'
      />
      <OurEmployees { ...ourEmployees } photo={ EmployeePhoto } />
    </div>
  );
};

export default OurMissionPage;
